import MarketingContentPage from "@/components/marketing/MarketingContentPage"

export default function About() {
  return <MarketingContentPage pageKey="about" seoKey="about" />
}
